import * as React from 'react';
import { Box } from '@material-ui/core';
import { Record, ReferenceInput, required, SelectInput } from 'react-admin';
import { RelatedEntityField, TranslationInput, WrapInput } from '../../common/custom-components';
import { useCheckAbilities } from '../../common/custom-hooks';
import { subject } from '@casl/ability';
import { titleWithFlagRenderer } from '../../common/optionRendererFactory';

interface Props {
  basePath: string;
  record: Record;
  resource: string;
}

const LanguageSection = (props: Props) => {
  const { ...fieldProps } = props;

  const [canUpdateLanguage, canUpdateTranslationOfId] = useCheckAbilities(can => [
    can('update', subject('Topic', fieldProps.record), 'language'),
    can('update', subject('Topic', fieldProps.record), 'translationOfId'),
  ]);

  return (
    <Box display={'flex'}>
      <WrapInput {...fieldProps} mr={1}>
        <ReferenceInput source="language" reference="language">
          <SelectInput disabled={!canUpdateLanguage} optionText="label" validate={required()} />
        </ReferenceInput>
      </WrapInput>
      <WrapInput {...fieldProps}>
        {fieldProps.record.translatedById ? (
          <RelatedEntityField
            reference={'topic'}
            source={'translatedById'}
            optionTextRenderer={titleWithFlagRenderer}
          />
        ) : (
          <TranslationInput
            label={'common.go_to_translation'}
            source={'translationOfId'}
            disabled={!canUpdateTranslationOfId}
            reference={'topic'}
            optionTextRenderer={titleWithFlagRenderer}
          />
        )}
      </WrapInput>
    </Box>
  );
};

export default LanguageSection;
